import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';

import SearchSettingsForm from '../../../components/siteadmin/SearchSettingsForm';
import Loader from '../../../components/Loader';

import { withQuery } from '../../../hoc/withGraphql';

import s from './SearchSettings.css';

const SearchSettings = (props) => {

  const { data: { loading, getSearchSettings }, title } = props;
  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return <SearchSettingsForm initialValues={getSearchSettings} title={title} />
  }
}

SearchSettings.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getSearchSettings: PropTypes.object,
  })
};

SearchSettings.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(gql`
        {
          getSearchSettings{
            id
            minPrice
            maxPrice
            priceRangeCurrency
          }
        }
      `,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(SearchSettings);
